import { useState, useEffect } from "react";
import searchMyProjectsClicked from "../../../../assets/images/searchMyProjectsClicked.svg";
import searchMyProjects from "../../../../assets/images/searchMyProjects.svg";
import filter from "../../../../assets/images/filter.svg";
import BlueFilterIcon from "../../../../assets/images/BlueFilterIcon.svg";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { Button as PrimeButton } from "primereact/button";
import Dropdown from "react-bootstrap/Dropdown";
import { Button } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import { ExportSelectedRows } from "../../../ExportCSV";
import _ from "lodash";
import { cloneDeep } from "lodash";
import { materialsExportCSVFlags } from "./utils";
import { exportExcelColumnNames } from "../../../../constants/dashboardConstants";
import CustomizeView from "../../../common/CustomizeView";
import WrapIcon from "../../../../assets/images/wrap-icon.png";
import {changeDateFormat} from "../../../../utils";


const MaterialsListHeader = ({
  isSearch = false,
  clearFilter,
  clearFiltersResetToDefault,
  onSearchClick,
  isFilterEnabled,
  isResetEnabled,
  handleDelegateClick,
  handleHelpNeededClick,
  handleHelpProvidedClick,
  actionFlag,
  selected,
  allData,
  filterFLag,
  CustomizeViewFlag,
  ResetToDefaultFlag,
  isTreeTableFlag,
  customizeViewFields,
  setCustomizeViewFields,
  projectColumnName,
  headerName,
  onChildClick,
  setTableRender,
  tableRender,
  isSpecialProject,
  bu,
  region,
  reorderColumnsSetColumnOrder,
  pgDefaultColumns,
  materialsWrapFreeText,
  setMaterialsWrapFreeText,
  setSettingsDialogVisible, // <-- now passed from parent
}) => {
  const [customizeViewVisible, setCustomizeViewVisible] = useState(false);

  const [enrichedCustomizeViewFields, setEnrichedCustomizeViewFields] =
    useState(customizeViewFields);

  let modifiedAllData = cloneDeep(allData);
  if (isTreeTableFlag) {
    modifiedAllData = allData?.map((obj) => {
      return obj.data;
    });
  }
  const [isClicked, setIsClicked] = useState(isSearch);
  const [isfilterClicked, setIsFilterClicked] = useState(false);

  const alterColumnsforExport = () => {
    let jsonValue =
      customizeViewFields && customizeViewFields?.length > 0
        ? JSON.parse(customizeViewFields)
        : null;
    const allSelectedData = jsonValue?.freezedColumns?.fieldsData
      ? (jsonValue?.freezedColumns?.fieldsData).concat(jsonValue?.selectedFields?.fieldsData)
      : jsonValue?.selectedFields?.fieldsData;
    let selectedData = allSelectedData ? allSelectedData.filter(colNames => colNames !== "Action") : exportExcelColumnNames;
    return selectedData;
  };

  // Enrich customizeViewFields with available fields when dialog opens
  useEffect(() => {
    if (!customizeViewVisible || !allData || allData.length === 0) {
      setEnrichedCustomizeViewFields(customizeViewFields);
      return;
    }

    try {
      const apiFields = Object.keys(allData[0]);
      const parsed =
        customizeViewFields && customizeViewFields.length > 0
          ? JSON.parse(customizeViewFields)
          : null;
      const selectedFields = parsed?.selectedFields?.fieldsData || [];
      const freezedFields = parsed?.freezedColumns?.fieldsData || [];
      const usedFields = parsed
        ? [...selectedFields, ...freezedFields]
        : projectColumnName?.map((col) => col.Field_Name) || [];

      const availableFieldNames = apiFields.filter((field) => !usedFields.includes(field));

      if (availableFieldNames.length > 0) {
        const enrichedData = parsed || {
          selectedFields: {
            fieldsData: projectColumnName?.map((col) => col.Field_Name) || [],
            id: "selectedFields",
            title: "Selected Fields",
          },
          freezedColumns: { fieldsData: [], id: "freezedColumns", title: "Freezed Fields" },
          availableFields: { fieldsData: [], id: "availableFields", title: "Available Fields" },
        };

        enrichedData.availableFields = {
          ...enrichedData.availableFields,
          fieldsData: availableFieldNames,
        };

        setEnrichedCustomizeViewFields(enrichedData);
      } else {
        setEnrichedCustomizeViewFields(customizeViewFields);
      }
    } catch (error) {
      setEnrichedCustomizeViewFields(customizeViewFields);
    }
  }, [customizeViewVisible, allData, customizeViewFields, projectColumnName]);

  const handleClick = () => {
    const newIsClicked = !isClicked;
    setIsClicked(newIsClicked);
    onSearchClick();
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };

  const handleClearFilter = () => {
    const newIsClicked = !isFilterEnabled;
    setIsClicked(newIsClicked);
    setIsFilterClicked(newIsClicked);
    clearFilter();
    if (onChildClick) {
      onChildClick(newIsClicked);
    }
  };
  let modifiedHeaders = alterColumnsforExport();

  modifiedAllData = modifiedAllData?.map((obj, index) => {
    obj["Design"] = materialsExportCSVFlags(obj.DesignFlag, isSpecialProject);
    obj["POA Number"] = obj.POANumber;
    obj["POA Description"] = obj.POADescription;
    obj["Country Of Sales"] = obj.CountryOfSales;
    obj["Assemble FA Status"] = obj.FAAssemblyState;
    obj["FA Approval (A/A/R)"] = obj.FAApproval.replace(/\//g, "|");
    obj["B:W"] = obj.BufferToWorkRatio;
    obj["B|W"] = obj.BufferToWork;
    obj["Req"] = changeDateFormat(obj.AWPrinterDate);
    obj["AWPrinterDate"] = changeDateFormat(obj.AWPrinterDate);
    obj["ETA"] = changeDateFormat(obj.POAReleaseDate);
    obj["Estimated AW Printer"] = changeDateFormat(obj.Estimated_AW_Printer);
    obj["Copy"] = obj?.ApprovedCopyElements?.toString() + "|" + obj?.TotalCopyElements?.toString();
    obj["Group"] = obj.AWM_GroupPMP;
    obj["PMP State"] = obj.PMPState;
    obj["TD State"] = obj.TDState;
    obj["POA Status"] = obj.POAStatus;
    obj["CIC"] = materialsExportCSVFlags(obj.CICFlag, isSpecialProject);
    obj["FA"] = materialsExportCSVFlags(obj.FAFlag.replace(/\//g, "|"), isSpecialProject);
    obj["RTA ProjectID"] = obj.RTA_ProjectID;
    obj["RTA Project Name"] = obj.RTA_Project_Name;
    obj["DSBP InitiativeID"] = obj.DSBP_InitiativeID;
    obj["DSBP Initiative Name"] = obj.DSBP_Initiative_Name;
    obj["PIMaterialNumber"] = obj.PIMaterialNumber;
    obj["PIMaterialID"] = obj.PIMaterialID;
    obj["PIMaterialDescription"] = obj.PIMaterialDescription;
    obj["Category"] = obj.Category;
    return obj;
  });

  const location = useLocation();

  const shouldShowResetButton =
    location.pathname.includes("/AllTasks") || location.pathname.includes("/MyTasks");

  const handleDelegate = () => {
    handleDelegateClick();
  };
  const handleHelpNeeded = () => {
    handleHelpNeededClick();
  };
  const handleHelpProvided = () => {
    handleHelpProvidedClick();
  };

  const locationPath = location?.pathname;
  const url = locationPath?.split("/");

  return (
    <div className="actions" style={{ paddingRight: 5}}>
      <div className="header-and-actions">
        {customizeViewVisible && (
          <>
            <CustomizeView
              onClose={() => setCustomizeViewVisible(!customizeViewVisible)}
              showTaskDialog={customizeViewVisible}
              setCustomizeViewFields={setCustomizeViewFields}
              customizeViewFields={enrichedCustomizeViewFields}
              availableFields={
                enrichedCustomizeViewFields.length
                  ? enrichedCustomizeViewFields?.availableFields?.fieldsData.map((col) => ({
                      Field_Name: col,
                    }))
                  : []
              }
              allColumns={projectColumnName.concat({ Field_Name: "PiFPCID" })}
              headerName={headerName}
              resetToPgDefault={() => clearFiltersResetToDefault()}
              setTableRender={setTableRender}
              tableRender={tableRender}
              BU={bu}
              region={region}
              reorderColumnsSetColumnOrder={reorderColumnsSetColumnOrder}
              pgDefaultColumns={pgDefaultColumns}
            />
          </>
        )}

        <div className="action-buttons">
          <img
            alt="filter"
            hidden={filterFLag}
            onClick={isFilterEnabled ? handleClearFilter : undefined}
            className={isFilterEnabled ? "header-icons" : ""}
            src={isFilterEnabled ? BlueFilterIcon : filter}
          />
          <img
            src={isClicked ? searchMyProjects : searchMyProjectsClicked}
            alt="search field"
            onClick={handleClick}
            className="header-icons"
          />

          {!shouldShowResetButton && (
            <>
              <ExportSelectedRows
                allData={modifiedAllData}
                selectedRows={selected}
                headers={modifiedHeaders}
                filename="Materials_Records"
              />
              <img
                src={WrapIcon}
                alt={materialsWrapFreeText ? "Unwrap Free Text" : "Wrap Free Text"}
                title={
                  materialsWrapFreeText ? "Unwrap Free Text Columns" : "Wrap Free Text Columns"
                }
                onClick={() => setMaterialsWrapFreeText((prev) => !prev)}
                style={{
                  cursor: "pointer",
                  margin: " 10px 0px",
                  width: "20px",
                  height: "20px",
                  filter: materialsWrapFreeText ? "none" : "grayscale(100%)",
                }}
              />
              <Button
                className="button-layout"
                variant="secondary"
                onClick={() => setCustomizeViewVisible(true)}
                hidden={CustomizeViewFlag}
                disabled={allData?.length == 0} //disable customize view if there is no data in the table
              >
                Customize View
              </Button>

              <button
                type="button"
                disabled={!isResetEnabled}
                className={
                  isResetEnabled ? "btn btn-primary reset-to-default-view" : "btn btn-disabled"
                }
                onClick={() => {
                  clearFiltersResetToDefault("globalReset");
                }}
                hidden={ResetToDefaultFlag}
              >
                Reset to Default
              </button>
            </>
          )}
          <>
            {shouldShowResetButton && (
              <>
                <ExportSelectedRows
                  selectedRows={selected}
                  allData={modifiedAllData}
                  headers={modifiedHeaders}
                />

                <DropdownButton
                  title="Action"
                  disabled={actionFlag}
                  id={actionFlag ? "tasksInActive" : "tasksActive"}
                  className="dropdown-button-custom"
                >
                  <Dropdown.Item onClick={handleDelegate}>Delegate</Dropdown.Item>
                  <Dropdown.Item onClick={handleHelpNeeded}>Help Needed</Dropdown.Item>
                  <Dropdown.Item onClick={handleHelpProvided}>Help Provided</Dropdown.Item>
                </DropdownButton>
              </>
            )}
          </>
        </div>
        <PrimeButton
          icon="pi pi-cog settings-cog-btn"
          className="p-button-text"
          onClick={() => setSettingsDialogVisible && setSettingsDialogVisible(true)}
          tooltip="Settings"
          tooltipOptions={{ position: "bottom" }}
          style={{ color: "#6c757d", marginLeft: "10px" }}
        />
      </div>
    </div>
  );
};

export default MaterialsListHeader;
